import { render, staticRenderFns } from "./Telephony.vue?vue&type=template&id=0ebfe0d2&"
import script from "./Telephony.vue?vue&type=script&lang=js&"
export * from "./Telephony.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports